<script lang="ts">
import { AppDropdownRangeComponent } from "./app-dropdown-range.ts";
export default AppDropdownRangeComponent;
</script>

<template>
    <app-dropdown
        type="single"
        :model-value="model"
        class="app-dropdown-range"
        :block-empty="blocked"
        :block-single="blocked"
        @opened="isOpen = true"
        @closed="isOpen = false"
    >
        <template v-slot:selected>
            <template v-if="canShowPlaceholder">
                {{ placeholder }}
            </template>
            <template v-else>
                {{ formattedFrom }} - {{ formattedTo }}
                <span v-if="unit">{{ unit }}</span>
            </template>
        </template>
        <template v-slot:dropdown-items>
            <li class="app-dropdown-item" v-if="isOpen">
                <app-range-slider
                    v-bind="$attrs"
                    v-model="model"
                    :options="items"
                ></app-range-slider>
            </li>
        </template>
    </app-dropdown>
</template>
